import { components } from 'react-select'

const SelectComponents = components

export { SelectComponents }
